export default __webpack_public_path__ + "static/media/logo-skinhealth.88452df6.jpg";